.breadcrumbsContainer {
  width: 100%;
  clear: both;
  background: var(--ogm-breadcrumb-bg-color);
}
@media (min-width: 1025px) {
  .breadcrumbsContainer {
    min-width: 998px;
    border-bottom: var(--ogm-border-bottom-1);
  }
}

.breadcrumbsWrapper {
  padding: 12px 16px;
  margin: auto;
  max-width: var(--ogm-max-width);
}
@media (min-width: 1025px) {
  .breadcrumbsWrapper {
    padding: 16px;
  }
}

.breadCrumbLi {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 5px;
  position: relative;
  margin-right: 5px;
  /* RR7 used `composes: fontBodyLM from '@cx-web/styles/font.module.css'`; inlined here so the shared
     component carries no cross-package CSS-module compose (which the lib build can't reliably resolve). */
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
}
@media (min-width: 1025px) {
  .breadCrumbLi {
    min-width: 20px;
    min-height: 20px;
  }
}
.breadCrumbLi span {
  text-transform: uppercase;
  line-height: 20px;
}

.breadCrumbText {
  display: flex;
  flex-wrap: nowrap;
  width: fit-content;
  white-space: nowrap;
}

.breadCrumbLink {
  color: #fff;
  text-decoration: none;
}

@media (min-width: 1025px) {
  .breadCrumbText {
    display: flex;
    flex-wrap: nowrap;
    width: fit-content;
    white-space: nowrap;
  }
}

@media (min-width: 1025px) {
  .breadCrumbLink {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }
}

.breadCrumbLast {
  font-family: var(--ogm-font-family-1);
  color: #fff;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 5px;
  overflow: auto;
  scrollbar-width: none;
}
.breadCrumbLast::-webkit-scrollbar {
  display: none;
}

@media (max-width: 1024px) {
  .breadCrumbText {
    display: inline;
    width: auto;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .breadCrumbLink {
    min-width: 0;
    max-width: 100%;
  }

  .breadCrumbLast {
    min-width: 0;
    max-width: 100%;
    display: block;
    width: 100%;
    overflow: visible;
  }

  .breadCrumbLi {
    max-width: 100%;
  }
}

@media (min-width: 1025px) {
  .breadCrumbLast {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }
}

.breadcrumbsOl {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  line-height: 21px;
  list-style: none;
  background: var(--ogm-breadcrumb-bg-color);
  width: 100%;
  align-items: center;
}
@media (min-width: 1025px) {
  .breadcrumbsOl {
    position: static;
    min-height: auto;
    line-height: inherit;
  }
}

.arrowWrap {
  position: relative;
  display: flex;
  align-items: center;
  width: 10px;
  height: 20px;
  align-self: start;
}

.arrow {
  position: static;
  display: flex;
  align-items: center;
  height: 20px;
  background-size: contain;
  transform: rotate(180deg);
  white-space: nowrap;
}
